"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormat = exports.CustomDateTimePicker = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var fa_1 = require("react-icons/fa");
var react_datepicker_1 = __importDefault(require("react-datepicker"));
require("../assets/css/custom-datetime-picker.css");
var TimeFormat;
(function (TimeFormat) {
    TimeFormat["H"] = "HH";
    TimeFormat["M"] = "mm";
    TimeFormat["HM"] = "HH:mm";
})(TimeFormat || (TimeFormat = {}));
exports.TimeFormat = TimeFormat;
// Manuel Türkçe locale objesi
var customTrLocale = {
    localize: {
        month: function (n) {
            var months = [
                "Ocak",
                "Şubat",
                "Mart",
                "Nisan",
                "Mayıs",
                "Haziran",
                "Temmuz",
                "Ağustos",
                "Eylül",
                "Ekim",
                "Kasım",
                "Aralık",
            ];
            return months[n];
        },
        day: function (n) {
            var days = ["Pzr", "Pts", "Sal", "Çrş", "Prş", "Cum", "Cts"];
            return days[n];
        },
    },
    formatLong: {
        date: function () { return "dd.MM.yyyy"; },
        time: function () { return "HH:mm"; },
        dateTime: function () { return "dd.MM.yyyy HH:mm"; },
    },
    options: {
        weekStartsOn: 1,
    },
};
var CustomDateTimePicker = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, value = _a.value, placeholder = _a.placeholder, _b = _a.required, required = _b === void 0 ? false : _b, errorMessage = _a.errorMessage, _c = _a.conditionalErrorVisible, conditionalErrorVisible = _c === void 0 ? false : _c, conditionalErrorMessage = _a.conditionalErrorMessage, tooltip = _a.tooltip, description = _a.description, _d = _a.disabled, disabled = _d === void 0 ? false : _d, className = _a.className, style = _a.style, showTimeSelect = _a.showTimeSelect, showTimeSelectOnly = _a.showTimeSelectOnly, showYearDropdown = _a.showYearDropdown, _e = _a.timeFormat, timeFormat = _e === void 0 ? TimeFormat.HM : _e, timeIntervals = _a.timeIntervals, submitted = _a.submitted, onChange = _a.onChange;
    // Eğer form gönderildiyse ve required field boşsa hata durumu geçerli olsun.
    var isInvalid = submitted && required && !value;
    return (react_1.default.createElement("div", { className: "col-12", style: style },
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement("label", { htmlFor: id, className: "form-label" }, label),
            react_1.default.createElement("div", { className: "position-relative" },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", overlay: tooltip ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "tooltip-".concat(id) }, tooltip)) : (react_1.default.createElement(react_1.default.Fragment, null)) },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_datepicker_1.default, { id: id, name: name, selected: value, onChange: onChange, className: "form-control ".concat(className || "", " ").concat(submitted ? (isInvalid ? "is-invalid" : "is-valid") : ""), placeholderText: placeholder, disabled: disabled, required: required, showTimeSelect: showTimeSelect || false, showTimeSelectOnly: showTimeSelectOnly || false, showYearDropdown: showYearDropdown || false, showTimeCaption: false, timeFormat: timeFormat, locale: customTrLocale, dateFormat: showTimeSelectOnly
                                ? timeFormat
                                : showTimeSelect
                                    ? "dd.MM.yyyy HH:mm"
                                    : "dd.MM.yyyy", timeIntervals: timeFormat === TimeFormat.H
                                ? 60
                                : timeFormat === TimeFormat.M
                                    ? 1
                                    : timeIntervals
                                        ? timeIntervals
                                        : 30 }))),
                react_1.default.createElement("div", { className: "invalid-feedback text-danger mt-2 ".concat(isInvalid ? "d-flex" : "") },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, errorMessage || "Tarih seçimi zorunludur."))),
                conditionalErrorVisible && (react_1.default.createElement("div", { className: "conditional-error-message text-warning mt-2" },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, conditionalErrorMessage)))),
                description && (react_1.default.createElement("div", { className: "form-description text-secondary mt-2" },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaInfoCircle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, description))))))));
};
exports.CustomDateTimePicker = CustomDateTimePicker;
exports.default = CustomDateTimePicker;
